import { render, staticRenderFns } from "./SyncInfoStatistics.vue?vue&type=template&id=0085b183&scoped=true&"
import script from "./SyncInfoStatistics.vue?vue&type=script&lang=js&"
export * from "./SyncInfoStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=0085b183&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0085b183",
  null
  
)

export default component.exports